<template>
<div>
    <Breadcrumbs main="Admin" submain="Resources" title="Asset Create" />
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label>Asset ID</label>
                                    <select class="form-control digits" v-model="asset.ast_ID">
                                        <option selected disabled>Select a type</option>
                                        <option v-for="(asset, index) in assetUnmarked" :key="index" :value="asset.ast_ID">{{ asset.ast_ID }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label>Name</label>
                                    <input class="form-control" type="text" placeholder="Enter asset name" v-model="asset.name">
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label>Type</label>
                                    <select class="form-control digits" v-model="asset.asset_type">
                                        <option selected disabled>Select a type</option>
                                        <option v-for="(type, index) in assetTypes" :key="index" :value="type.id">{{ type.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label>Amount</label>
                                    <input class="form-control" type="number" placeholder="Enter asset amount" v-model="asset.amount">
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label>Status</label>
                                    <select class="form-control digits" v-model="asset.status">
                                        <option v-for="(status, index) in statuses" :key="index">{{ status }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label>Camp</label>
                                    <select class="form-control digits" v-model="asset.location" @change="getBlocksByCamp(asset.location)">
                                        <option selected disabled>Select a location</option>
                                        <option v-for="(loc, index) in location" :key="index" :value="loc.id">{{ loc.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label>Block</label>
                                    <select class="form-control digits" v-model="asset.block">
                                        <option selected disabled>Select a block</option>
                                        <option v-for="(block, index) in blocks" :key="index" :value="block.id">{{ block.name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label>Address Line</label>
                                    <input class="form-control" type="text" placeholder="Enter address line" v-model="asset.address_line">
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label>Purchase Date</label>
                                    <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" v-model="asset.purchase_date"></datepicker>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label>Manufacture Date</label>
                                    <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" v-model="asset.manufacture_date"></datepicker>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label>Warranty End</label>
                                    <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" v-model="asset.warranty_end"></datepicker>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label>Items</label>
                                    <ItemTable style="margin-bottom: 10px;" @itemsUpdated="updateItems" />
                                </div>
                            </div>
                        </div>

                        <div class="row mt-4">
                            <div class="col">
                                <div class="form-group">
                                    <label>Asset Photo</label>
                                    <div class="flex items-center">
                                        <input type="file" accept="image/*" @change="uploadFile">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-2">
                            <div class="col">
                                <div class="form-group">
                                    <label>Upload Attachment</label>
                                    <b-form-file v-model="asset.asset_attachment" placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." @change="uploadAttachment"></b-form-file>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-1">
                            <div class="col">
                                <div class="form-group">
                                    <label>Asset Details</label>
                                    <b-form-textarea id="textarea-auto-height" placeholder="Enter asset details..." v-model="asset.details" rows="4" max-rows="13"></b-form-textarea>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col">
                                <div class="form-group mb-0">
                                    <button @click="onSubmit" class="btn btn-success mr-3">Create</button>
                                    <router-link to="/resources/asset/list">
                                        <button class="btn btn-danger" href="#">Go Back</button>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import {
    mapState
} from 'vuex';
import {
    myHost
} from '../../../_helpers/host';
import Datepicker from 'vuejs-datepicker';
import moment from "moment";
import ItemTable from "./item-table.vue";

export default {
    components: {
        Datepicker,
        ItemTable
    },

    data() {
        return {
            host: myHost.host,
            statuses: ['ACTIVE', 'UNDER MAINTENANCE', 'APPROVAL PENDING', 'INACTIVE'],
            asset: {
                ast_ID: null,
                name: '',
                status: null,
                image: null,
                asset_type: null,
                location: null,
                block: null,
                address_line: '',
                warranty_end: null,
                details: '',
                specification: [],
                amount: null,
                purchase_date: null,
                manufacture_date: null,
                asset_attachment: null
            }
        };
    },

    computed: {
        ...mapState({
            assetUnmarked: state => state.asset.assetUnmarked,
            assetTypes: state => state.asset.assetType,
            location: state => state.camp.camp,
            blocks: state => state. block. block
        })
    },

    mounted() {
        this.$store.dispatch("asset/fetchUnmarkedAssetIDs")
        this.$store.dispatch("camp/fetchCamp")
        this.$store.dispatch("asset/fetchType")
        this.$store.dispatch("block/fetchBlock")
    },

    methods: {
        getBlocksByCamp(camp_id) {
            this.$store.dispatch("block/getBlocksByCamp", camp_id)
        },

        updateItems(data) {
            if (data) {
                this.asset.specification = data;
            }
        },

        uploadAttachment(e) {
            this.asset.asset_attachment = e.target.files[0];
        },

        uploadFile(e) {
            console.log(e.target.files[0])
            this.asset.image = e.target.files[0];
        },

        onSubmit() {
            if (this.asset.warranty_end !== null) {
                this.asset.warranty_end = moment(String(this.asset.warranty_end)).format("YYYY-MM-DD");
            }
            if (this.asset.manufacture_date !== null) {
                this.asset.manufacture_date = moment(String(this.asset.manufacture_date)).format("YYYY-MM-DD");
            }
            if (this.asset.purchase_date !== null) {
                this.asset.purchase_date = moment(String(this.asset.purchase_date)).format("YYYY-MM-DD");
            }

            this.asset.name = this.asset.name.trim() ? this.asset.name : null;

           if(this.asset.ast_ID && this.asset.name) {
                this.$store.dispatch("asset/addAsset", this.asset).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.asset.ast_ID = null
                        this.asset.name = null
                        this.asset.status = null
                        this.asset.image = null
                        this.asset.asset_type = null
                        this.asset.location = null
                        this.asset.block = null
                        this.asset.address_line = null
                        this.asset.warranty_end = null
                        this.asset.details = null
                        this.asset.specification = []
                        this.asset.amount = null
                        this.asset.purchase_date = null
                        this.asset.manufacture_date = null
                        this.asset.asset_attachment = null
                        setTimeout(() => {
                            this.$router.push('/resources/asset/list')
                        }, 2000)
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
            } else {
                Swal.fire({
                    title: "Warn!",
                    text: "You must enter asset id & name",
                    icon: "warning"
                });
            }
        }
    }
};
</script>
